'use strict';

const { h } = require('phy');
const { Translate } = require('@grpn/preact-l10n');
const DateTime = require('@grpn/preact-l10n/datetime');

function getRow({ offerTitle, offerType, isExclusive, expiryDateTime }) {
  return h('tr.offers-table-row', [
    h('td.offers-table-col', offerTitle),
    h('td.offers-table-col', [
      isExclusive && [h(Translate, 'modules.shared.Exclusive'), ' '],
      h(
        Translate,
        `modules.merchant.AnswerBoxOfferTypeDescription.${offerType}`
      ),
    ]),
    h(
      'td.offers-table-col',
      h(DateTime, {
        value: new Date(expiryDateTime),
        format: 'DD MMM',
      })
    ),
  ]);
}

function filterOffers(offers) {
  return offers
    .filter(
      ({ offerTitle, financialTerms }) =>
        !!offerTitle && financialTerms.length === 0
    )
    .slice(0, 6)
    .reverse();
}

function MerchantOffersTable({ offers = [] }) {
  const offersList = filterOffers(offers);

  if (!offersList.length) {
    return h(
      'p.offers-table-empty',
      h(Translate, 'modules.merchant.NoExpiredOffers')
    );
  }

  return h(
    'table.offers-table',
    h(
      'thead',
      h('tr', [
        h(
          'th.offers-table-heading',
          h(Translate, 'modules.merchant.AnswerBoxCodeTitleHeading')
        ),
        h(
          'th.offers-table-heading',
          h(Translate, 'modules.merchant.AnswerBoxDiscountTypeHeading')
        ),
        h(
          'th.offers-table-heading',
          h(Translate, 'modules.merchant.AnswerBoxExpiryDateHeading')
        ),
      ])
    ),
    h('tbody', offersList.map(offer => getRow(offer)))
  );
}

module.exports = MerchantOffersTable;
